module.exports = __webpack_public_path__ + "img/template-background.9135d795.svg";